import React from "react";
import {
  DataTable,
  DataTableBody,
  DataTableCell,
  DataTableHeader,
  DataTableHeaderCell,
  DataTableRow
} from "@cdk-uip/react-data-table";
import { Checkbox } from "@cdk-uip/react-checkbox";
import InvoiceConfigurationHelpTooltip from "./InvoiceConfigurationHelpTooltip";
import initConfig from "../config/InvoiceConfiguration";
import "./InvoiceConfigurationDataTable.css";
class InvoiceConfigurationDataTable extends React.Component {
  state = {
    dialogOpen: false,
    helpImage: null,
    configurations: initConfig
  };

  render() {
    return (
      <React.Fragment>
        <DataTable className="mmi-config-table">
          <DataTableHeader>
            <DataTableRow>
              <DataTableHeaderCell nonNumeric>Section</DataTableHeaderCell>
              <DataTableHeaderCell nonNumeric>Description</DataTableHeaderCell>
              <DataTableHeaderCell nonNumeric></DataTableHeaderCell>
              <DataTableHeaderCell nonNumeric>Summary</DataTableHeaderCell>
              <DataTableHeaderCell nonNumeric>Detail</DataTableHeaderCell>
            </DataTableRow>
          </DataTableHeader>
          <DataTableBody className="mmi-config-body">
            {initConfig.map(config => (
              <DataTableRow key={config.id}>
                <DataTableCell nonNumeric>{config.section}</DataTableCell>
                <DataTableCell nonNumeric>{config.description}</DataTableCell>
                <DataTableCell>
                  <InvoiceConfigurationHelpTooltip
                    config={config}
                  ></InvoiceConfigurationHelpTooltip>
                </DataTableCell>
                <DataTableCell nonNumeric>
                  {config.summary.type === "bool" ? (
                    <Checkbox
                      name={config.summary.key}
                      checked={this.props.config[config.summary.key]}
                      onChange={this.props.handleChange}
                    ></Checkbox>
                  ) : (
                    <span className="mmi-config-na">
                      {config.summary.value}
                    </span>
                  )}
                </DataTableCell>
                <DataTableCell nonNumeric>
                  {config.detail.type === "bool" ? (
                    <Checkbox
                      name={config.detail.key}
                      checked={this.props.config[config.detail.key]}
                      onChange={this.props.handleChange}
                    ></Checkbox>
                  ) : (
                    config.detail.value
                  )}
                </DataTableCell>
              </DataTableRow>
            ))}
          </DataTableBody>
        </DataTable>
      </React.Fragment>
    );
  }
}

export default InvoiceConfigurationDataTable;
